.cameraPassthrough,
.canvas,
.labelRoot {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.labelRoot {
  isolation: isolate;
  overflow: hidden;
  pointer-events: none;
}

.label {
  color: white;
  text-shadow:
    -1px -1px 0 #000,
    1px -1px 0 #000,
    -1px 1px 0 #000,
    1px 1px 0 #000;
}
